import {storageProxy} from 'interactors/storageProxy';
import {VERSION_STORAGE_KEY as key} from '../config';
import {SetupDependencies} from '../types';

export function saveVersion(version: string, di: SetupDependencies = {}): void {
  const {storage = storageProxy} = di;
  storage.setItem(key, version);
}
